module.exports = __webpack_public_path__ + "img/gd-fiori-clock.68f9eb03.png";